module.exports = __webpack_public_path__ + "odstraneni-tetovaze_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_5_after.jpg
// module id = 961
// module chunks = 0